import { FC } from "react";
import styles from "./main.module.css";

export interface LabelProps {
  labelArray: any[];
  removeMargin?: boolean;
  total?:number;
  title?: string;
}

const Label: FC<LabelProps> = ({ labelArray, total=0, title, removeMargin = false }) => {
  return (
    <main
      style={{ height: `${removeMargin ? "auto" : "322px"}` }}
      className={styles.labelWrapper}
    >
      <header> Total {title} </header>
      {/* <h1> </h1> */}

      

      {labelArray.map((item: any, index: number) => (
        <div key={index}>
          <div
            style={{ background: `${item.color}` }}
            className={styles.circle}
          ></div>

          <span>{item.name}</span>
        </div>
      ))}
    </main>
  );
};

export default Label;
